import WidgetEntity from '../WidgetEntity';
import * as Widgets from '@mm/constants/widgets';

export class TagsWidget extends WidgetEntity {
  static make(pageId: number, sortOrder: number) {
    return {
      ...super.make(pageId, Widgets.TAGS, '', sortOrder),
      config: {
        tags: [],
        kind: 'add_tags',
      },
    };
  }
}
